import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class AceitesService extends BaseService {
  getBaseAtas() {
    const url = `${environment.portalApi}/Aceites/GetBaseAtas`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  getAtas(model: any) {
    const url = `${environment.portalApi}/Aceites/GetAtas?` + this.paramsToQueryString(model);
    return this.http.get(url, { headers: this.createHeader() });
  }
  getAtaFile(id: number) {
    const url = `${environment.portalApi}/Aceites/GetAtaFile?id=` + id;
    return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
  }
  PostProvaVida(model: any) {
    const url = `${environment.portalApi}/Aceites/PostProvaVida`;
    return this.http.post(url, model, { headers: this.createHeader() });
  }
  GetValidacaoProvaVida() {
    const url = `${environment.portalApi}/Aceites/GetValidacoes`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  GetRecadastramento() {
    const url = `${environment.portalApi}/Aceites/GetRecadastramento`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  PostRecadastramento() {
    const url = `${environment.portalApi}/Aceites/PostRecadastramento`;
    return this.http.post<any>(url, { headers: this.createHeader() });
  }
  GetActualBankAccount() {
    const url = `${environment.portalApi}/Aceites/GetActualBankAccount`;
    return this.http.get(url, { headers: this.createHeader() });
  }
  PostActualBankAccount() {
    const url = `${environment.portalApi}/Aceites/PostActualBankAccount`;
    return this.http.post(url, { headers: this.createHeader() });
  }
}
